import { computed, onMounted, onUnmounted } from 'vue'
import { useIntervalFn } from '@vueuse/core'

import { OngoingReport } from '@/types/dashboard'
import { FetchParameters, useOngoingReportStore } from '@/stores/ongoing-driver-report-store'
import { useDashboardStore } from '@/stores/dashboard-store'
import { useAuthStore } from '@/stores/auth-store'

/**
 * Fetches all necessary data and options for an ongoing report widget
 */
export function useOngoingReportWidgetData() {
    const authStore = useAuthStore()
    const dashboardStore = useDashboardStore()
    const ongoingReportStore = useOngoingReportStore()

    const fetchParameters = computed<FetchParameters>(() => {
        return {
            dashboardId: dashboardStore.currentDashboard?.id ?? '',
            shareToken: !authStore.user ? dashboardStore.currentDashboard!.shareToken : null,
        }
    })
    const reports = computed<OngoingReport[]>(() => {
        const fetchParameterKey = ongoingReportStore.getFetchParametersKey(fetchParameters.value)

        return ongoingReportStore.reports[fetchParameterKey] ?? []
    })
    const loading = computed(() => {
        const fetchParameterKey = ongoingReportStore.getFetchParametersKey(fetchParameters.value)

        return ongoingReportStore.fetching[fetchParameterKey] ?? false
    })

    async function fetchOngoingReports() {
        ongoingReportStore.fetch(fetchParameters.value)
    }

    // We'll update every minute here instead of following the dashboard's refresh interval.
    // This is because it uses "live" data
    const { pause } = useIntervalFn(fetchOngoingReports, 1_000 * 60)

    onMounted(() => fetchOngoingReports())
    onUnmounted(() => pause())

    return { reports, loading, fetchOngoingReports }
}
